defer(function () {
  const MONEY_REGEX = /\B(?=(\d{3})+(?!\d))/g;

  const regiones = {
    "AN": "Antofagasta",
    "AR": "Araucanía",
    "AP": "Arica y Parinacota",
    "AT": "Atacama",
    "AI": "Aysén",
    "BI": "Biobio",
    "CO": "Coquimbo",
    "LL": "Los Lagos",
    "LR": "Los Rí­os",
    "MA": "Magallanes",
    "ML": "Maule",
    "RM": "Región Metropolitana",
    "NB": "Ñuble",
    "LI": "O'Higgins",
    "TA": "Tarapacá",
    "VS": "Valparaí­so"
  };

  const comunas = {
    "AN": ["Antofagasta", "Calama", "María Elena", "Mejillones", "Ollagüe", "San Pedro de Atacama", "Sierra Gorda", "Taltal", "Tocopilla"],
    "AR": ["Angol", "Carahue", "Cholchol", "Collipulli", "Cunco", "Curacautín", "Curarrehue", "Ercilla", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Lonquimay", "Los Sauces", "Lumaco", "Melipeuco", "Nueva Imperial", "Padre las Casas", "Perquenco", "Pitrufquén", "Pucón", "Purén", "Renaico", "Saavedra", "Temuco", "Teodoro Schmidt", "Toltén", "Traiguén", "Victoria", "Vilcún", "Villarrica"],
    "AP": ["Arica", "Camarones", "General Lagos", "Putre"],
    "AT": ["Alto del Carmen", "Caldera", "Chañaral", "Copiapó", "Diego de Almagro", "Freirina", "Huasco", "Tierra Amarilla", "Vallenar"],
    "AI": ["Aisén", "Chile Chico", "Cisnes", "Cochrane", "Coihaique", "Guaitecas", "Lago Verde", "O’Higgins", "Río Ibáñez", "Tortel"],
    "BI": ["Alto Biobío", "Antuco", "Arauco", "Cabrero", "Cañete", "Chiguayante", "Concepción", "Contulmo", "Coronel", "Curanilahue", "Florida", "Hualpén", "Hualqui", "Laja", "Lebu", "Los Álamos", "Los Ángeles", "Lota", "Mulchén", "Nacimiento", "Negrete", "Penco", "Quilaco", "Quilleco", "San Pedro de la Paz", "San Rosendo", "Santa Bárbara", "Santa Juana", "Talcahuano", "Tirúa", "Tomé", "Tucapel", "Yumbel"],
    "CO": ["Andacollo", "Canela", "Combarbalá", "Coquimbo", "Illapel", "La Higuera", "La Serena", "Los Vilos", "Monte Patria", "Ovalle", "Paihuano", "Punitaqui", "Río Hurtado", "Salamanca", "Vicuña"],
    "LL": ["Ancud", "Calbuco", "Castro", "Chaitén", "Chonchi", "Cochamó", "Curaco de Vélez", "Dalcahue", "Fresia", "Frutillar", "Futaleufú", "Hualaihué", "Llanquihue", "Los Muermos", "Maullín", "Osorno", "Palena", "Puerto Montt", "Puerto Octay", "Puerto Varas", "Puqueldón", "Purranque", "Puyehue", "Queilén", "Quellón", "Quemchi", "Quinchao", "Río Negro", "San Juan de la Costa", "San Pablo"],
    "LR": ["Corral", "Futrono", "La Unión", "Lago Ranco", "Lanco", "Los Lagos", "Mariquina", "Máfil", "Paillaco", "Panguipulli", "Río Bueno", "Valdivia"],
    "MA": ["Antártica", "Cabo de Hornos (Ex Navarino)", "Laguna Blanca", "Natales", "Porvenir", "Primavera", "Punta Arenas", "Río Verde", "San Gregorio", "Timaukel", "Torres del Paine"],
    "ML": ["Cauquenes", "Chanco", "Colbún", "Constitución", "Curepto", "Curicó", "Empedrado", "Hualañé", "Licantén", "Linares", "Longaví", "Maule", "Molina", "Parral", "Pelarco", "Pelluhue", "Pencahue", "Rauco", "Retiro", "Romeral", "Río Claro", "Sagrada Familia", "San Clemente", "San Javier", "San Rafael", "Talca", "Teno", "Vichuquén", "Villa Alegre", "Yerbas Buenas"],
    "RM": ["Alhué", "Buin", "Calera de Tango", "Cerrillos", "Cerro Navia", "Colina", "Conchalí", "Curacaví", "El Bosque", "El Monte", "Estación Central", "Huechuraba", "Independencia", "Isla de Maipo", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "María Pinto", "Melipilla", "Ñuñoa", "Padre Hurtado", "Paine", "Pedro Aguirre Cerda", "Peñaflor", "Peñalolén", "Pirque", "Providencia", "Pudahuel", "Puente Alto", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Bernardo", "San Joaquín", "San José de Maipo", "San Miguel", "San Pedro", "San Ramón", "Santiago", "Talagante", "Tiltil", "Vitacura"],
    "NB": ["Bulnes", "Chillán", "Chillán Viejo", "Cobquecura", "Coelemu", "Coihueco", "El Carmen", "Ninhue", "Pemuco", "Pinto", "Portezuelo", "Quillón", "Quirihue", "Ránquil", "San Carlos", "San Fabián", "San Ignacio", "San Nicolás", "Treguaco", "Yungay", "Ñiquén"],
    "LI": ["Chimbarongo", "Chépica", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "La Estrella", "Las Cabras", "Litueche", "Lolol", "Machalí", "Malloa", "Marchihue", "Mostazal", "Nancagua", "Navidad", "Olivar", "Palmilla", "Paredones", "Peralillo", "Peumo", "Pichidegua", "Pichilemu", "Placilla", "Pumanque", "Quinta de Tilcoco", "Rancagua", "Rengo", "Requínoa", "San Fernando", "San Vicente", "Santa Cruz"],
    "TA": ["Alto Hospicio", "Camiña", "Colchane", "Huara", "Iquique", "Pica", "Pozo Almonte"],
    "VS": ["Algarrobo", "Cabildo", "Calera", "Calle Larga", "Cartagena", "Casablanca", "Catemu", "Concón", "El Quisco", "El Tabo", "Hijuelas", "Isla de Pascua", "Juan Fernández", "La Cruz", "La Ligua", "Limache", "Llaillay", "Los Andes", "Nogales", "Olmué", "Panquehue", "Papudo", "Petorca", "Puchuncaví", "Putaendo", "Quillota", "Quilpué", "Quintero", "Rinconada", "San Antonio", "San Esteban", "San Felipe", "Santa María", "Santo Domingo", "Valparaíso", "Villa Alemana", "Viña del Mar", "Zapallar"]
  };

  document.getElementById("header_quote").addEventListener("click", openQuoteListener, false);
  document.getElementById("close_quote").addEventListener("click", closeQuoteListener, false);
  document.getElementById("ver_price").addEventListener("click", openQuoteFormListener, false);
  document.getElementById("close_form_quote").addEventListener("click", closeQuoteFormListener, false);

  delegate(document, "click", "#add_to_price", addToQuoteListener);
  delegate(document, "click", "#delete_prod", removeFromQuoteListener);

  //Lab51AsyncLoad(["https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js", "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"]);
  update_quote_cart();

  // load_comunas();

  function openQuoteListener(event) {
    event.preventDefault();
    addClassById("quote_cart", "show");
    //console.log('open');
  }

  function openQuoteFormListener(event) {
    event.preventDefault();
    let element = document.getElementById("quote_cart");
    removeClassById("quote_cart", "show");
    addClassById("popup_cotizar", "show");
    load_quote();
    document.getElementById("ContactFormName").focus();
  }

  function closeQuoteListener(event) {
    event.preventDefault();
    removeClassById("quote_cart", "show");
  }

  function closeQuoteFormListener(event) {
    event.preventDefault();
    removeClassById("popup_cotizar", "show");
  }

  function addToQuoteListener(event) {
    event.preventDefault();

    let cotizadorJson = JSON.parse(getQuote('lab51_cotizador'));
    let proID      = PRODUCT_JSON.id !== null ? PRODUCT_JSON.id : PRODUCT_JSON.id;
    let proTitle      = PRODUCT_JSON.title !== null ? PRODUCT_JSON.title : PRODUCT_JSON.title;
    let proSKU     = PRODUCT_JSON.variants[0].sku !== null ? PRODUCT_JSON.variants[0].sku : PRODUCT_JSON.variants[0].sku;
    let proPrice      = PRODUCT_JSON.variants[0].compare_at_price !== null ? PRODUCT_JSON.variants[0].compare_at_price : PRODUCT_JSON.variants[0].price;
    let imagen      = PRODUCT_JSON.variants[0].featured_image !== null ? PRODUCT_JSON.variants[0].featured_image: PRODUCT_JSON.featured_image;

    cotizadorJson.cotizador.push(JSON.parse(`{"extra": "${proTitle}", "id": "${proID}", "image": "${imagen}", "price": "${proPrice}", "quantity": "${document.querySelector(".input-cantidad input[name=quantity]").value}", "sku": "${proSKU}", "title": "${proTitle}", "token": "${uuidv4()}"}`));
    setQuote("lab51_cotizador", JSON.stringify(cotizadorJson));
    update_quote_cart(true, true);
  }

  function load_comunas() {
    let region_select = document.querySelector("#select-region");
    let comuna_select = document.querySelector("#select-comuna");

    region_select.append(new Option("Selecciona tu Región", ""));
    comuna_select.append(new Option("Selecciona tu Comuna", ""));

    // populate cities
    Object.keys(regiones).forEach(function(region) {
      let option = new Option(regiones[region], region);
      region_select.append(option);
    });

    region_select.addEventListener("change", repopulateTowns, false);
  }

  /**
   * Escucha permanente para borrar producto del minicotizador
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  function removeFromQuoteListener(event) {
    event.preventDefault();
    checkQuote('lab51_cotizador');

    let cotizadorJson = JSON.parse(getQuote('lab51_cotizador'));
    let dataRemoved   = cotizadorJson.cotizador.filter((el) => {
      if (typeof(el) != "undefined") {
        return el.token !== this.dataset.token;
      }
    });
    setQuote('lab51_cotizador', '{"cotizador": ' + JSON.stringify(dataRemoved) + '}');
    update_quote_cart(true, true);
  };

  function repopulateTowns() {
    let comuna_select = document.querySelector("#select-comuna");
    if (this.value !== "") {
      let this_comuma = this.value;
      comuna_select.innerHTML = "";
      Object.keys(comunas[this_comuma]).forEach(function(index) {
        let comuna_value = comunas[this_comuma][index];
        comuna_select.append(new Option(comuna_value, comuna_value));
      });
    } else {
      comuna_select.innerHTML = "";
      comuna_select.append(new Option("Selecciona tu Comuna", ""));
    }
  }

  /**
  * Actualiza el cotizador
  *
  * @param boolean show   Muestra el menu
  * @param boolean all    Actualiza el sector medio del mini carro
  * @param boolean slick  Inicializa slick
  */
  function update_quote_cart(show = false, all = true, slick = true) {
    checkQuote('lab51_cotizador');

    let cotizacionJson = JSON.parse(getQuote('lab51_cotizador'));
    let itemcount      = 0;
    let suma_total     = 0;
    let proMini        = "";

    if (all) {
      document.querySelector("#quote_cart .middle ul").innerHTML = "";
      unslick();
    }

    document.querySelector("#quote_cart .cifra") ? document.querySelector("#quote_cart .cifra").innerHTML = "" : null;

    cotizacionJson.cotizador.forEach((item) => {
      let price;
      if (item.price > 500000000) {
        price   = '';
      } else {
        price   = '$' + item.price ? money_separator(item.price) : "0";
      }
      let imagen  = item.image;
      itemcount  += parseInt(item.quantity);
      suma_total += item.price * item.quantity;
      proMini    += `<li><div class="left"><i id="delete_prod" class="delete-prod" data-token="${item.token}"></i><h4>${item.title}</h4><h5>${price}</h5><h6>Cantidad: <span>${item.quantity}</span></h6></div><div class="right"><img src="${imagen}" alt="" /></div></li>`;
    });

    console.log({ itemcount });
    console.log({ maxCotizar });

    if (itemcount > maxCotizar) {
      $('#add_to_price').hide(100);
    } else {
      $('#add_to_price').show(100);
    }

    document.querySelector("#quote_cart .cifra") ? document.querySelector("#quote_cart .cifra").innerHTML = `$${money_separator(suma_total)}` : null;
    document.querySelector(".price .count").innerHTML     = itemcount;
    
    if (all) {
      document.querySelector("#quote_cart .middle ul").innerHTML = proMini;
      slick_price();
    }

    if (show) {
      let element = document.getElementById("quote_cart");
      element.classList.add("show");
    }
  }

  /**
   * Actualiza el cotizador
   *
   * @param boolean show  Muestra el menu
   * @param boolean all   Actualiza el sector medio del mini carro
   */
  function load_quote() {
    checkQuote('lab51_cotizador');

    let jsonQuote = JSON.parse(getQuote("lab51_cotizador"));
    let proMini   = "Cotización\n\n";

    jsonQuote.cotizador.forEach((item) => {
      let price;
      if (item.price > 500000000) {
        price   = '';
      } else {
        price   = '$' + item.price ? money_separator(item.price) : "0";
      }
      proMini  += `Producto: ${item.title} \nSKU: ${item.sku}\nCantidad: ${item.quantity}\nPrecio: ${price}\n\n`;
    });

    document.querySelector("#popup_cotizar #ContactFormMessage").innerHTML = proMini;
  }

  function setQuote(name, value) {
    localStorage.setItem(name, encodeURIComponent(value));
  }

  function deleteQuote(name) {
    localStorage.removeItem(name);
  }

  function getQuote(name) {
    var quoteData = localStorage.getItem(name);
    if (quoteData !== '' && quoteData !== undefined && quoteData !== null ) {   
      return decodeURIComponent(quoteData);
    } else {
      return "";
    }
  }

  function checkQuote(name) {
    var quoteData = getQuote(name);
    if (quoteData != "" && quoteData != null && quoteData != undefined) {
      return true;
    } else {
      setQuote('lab51_cotizador', '{"cotizador":[]}');
      return false;
    }
  }

  function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }

  function money_separator(amount) {
    return (amount / 100).toString().replace(MONEY_REGEX, ".");
  }

  /**
  ** Actualiza el cotizador
  **
  ** @param object   el       Elemento global del DOM de escucha
  ** @param string   evt      Evento de escucha
  ** @param string   sel      Elemento que de escucha
  ** @param function handler  Función a ejecutar
  **/
  function delegate(el, evt, sel, handler) {
    //console.log(typeof(handler));
    el.addEventListener(evt, function(event) {
      var t = event.target;
      while (t && t !== this) {
        if (t.matches(sel)) {
          handler.call(t, event);
        }
        t = t.parentNode;
      }
    });
  }

  function unslick() {
      try {
        $('#quote_cart .middle ul').slick('unslick');
      } catch(e) {}
  }

  function slick_price() {
        $('#quote_cart .middle ul').slick({
          dots: false,
          arrows: true,
          adaptiveHeight: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 830,
              settings: {
                dots: false,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        });
  }

  function removeClassById(id_name, class_name) {
    let element = document.getElementById(id_name);
    element.classList.remove(class_name);
  }

  function addClassById(id_name, class_name) {
    let element = document.getElementById(id_name);
    element.classList.add(class_name);
  }
}, 0);